import type { IconData } from '@stacksjs/iconify-core'

export const watch1Remix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.838 10.06A18.46 18.46 0 0 0 5.5 24a18.46 18.46 0 0 0 6.337 13.94l1.125 4.567l.009.033c.613 2.268 2.357 4.258 4.952 4.606c1.456.196 3.447.354 6.077.354s4.621-.158 6.077-.354c2.594-.348 4.339-2.338 4.952-4.606l.004-.014l.004-.019l1.125-4.566A18.46 18.46 0 0 0 42.5 24c0-5.562-2.454-10.55-6.34-13.942l-1.155-4.682l-.003-.01l-.005-.022c-.6-2.22-2.338-4.142-4.9-4.487C28.64.66 26.641.5 24 .5c-2.643 0-4.64.16-6.098.357c-2.562.345-4.3 2.267-4.9 4.487l-.008.032zM9.5 24c0-8.008 6.492-14.5 14.5-14.5S38.5 15.992 38.5 24S32.008 38.5 24 38.5S9.5 32.008 9.5 24\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default watch1Remix
